import React from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import isLoggedIn from '../../../utils/auth';
import {
	formatCost, 
	formatLocation, 
	getUrlId, 
} from '../../../utils/formatting';

import RhinoLoading from '../common/RhinoLoading';

import * as authActionCreators from '../../../actions/auth';
import * as jewelryActionCreators from '../../../actions/jewelry';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, authActionCreators, jewelryActionCreators, leadsActionCreators, messagesActionCreators, usersActionCreators);

class SingleJewelry extends React.Component {
  

	constructor(props) {

		super(props);

		this.jewelrySku = getUrlId().replace('?', '');

		this.state = {

			jewelrySku: this.jewelrySku,
			jewelry: null,

			transferMessage: '',
			transferName: '',
			transferApptDate: '',
			transferApptTime: '',
			transferBudget: '',

			transferApptDateError: '',

			requestSent: false,

			jewelryNotFound: false,
		}

		if(this.state.jewelrySku === null) {
			this.userNav('');
		}

		// Load jewelry data;
		this.fetchJewelry(this.jewelrySku);
	}

  componentDidUpdate(prevProps) {
    if(this.state.jewelrySku) {
      const currentSku = getUrlId().replace('?', '');
      if(currentSku !== this.state.jewelrySku) {
        this.fetchJewelry(currentSku);
      }
    }
  }

  fetchJewelry(jewelrySku = '') {
    
    if(!jewelrySku ) { return null; }

    if (window.location.href.includes('/barcode/') || this.looksLikeBarcode(jewelrySku)) {

      this.props.fetchJewelryByBarcodeId(jewelrySku)
        .then((respData) => {

          const jewelryObj = respData?.success && respData.product ? respData.product : null;

          this.setState({ 
            jewelry: jewelryObj,
            jewelryNotFound: jewelryObj === null,
          });
        })
        .catch((errorResp) => {
          console.error(errorResp);
          this.setState({
            jewelryNotFound: true,
          })
        });
    } else {

      this.props.fetchJewelryByAscId(jewelrySku)
        .then((respData) => {

        const jewelryObj = respData?.success && respData.product ? respData.product : null;

          this.setState({ 
            jewelry: jewelryObj,
            jewelryNotFound: jewelryObj === null,
          });
        })
        .catch((errorResp) => {
          console.error(errorResp);
          this.setState({
            jewelryNotFound: true,
          });
        });
    }
  }

  looksLikeBarcode(sku) {
    if(!sku) return false;
    return /^\d+$/.test(sku) && sku.startsWith("11");
  }

	userNav(page) {
		history.push('/' + page);
	}

	getCost(diamond) {
		if(!isLoggedIn() || diamond.cost === null || diamond.cost === 0) {
			return '';
		} else {
			if(this.props.auth.hideData) {
				return '';
			} else {
				return '(' + formatCost(diamond) + ')';
			}
		}
	}

	backButtonNav() {
		window.history.back();
	}

  render() {
    return <div className='SingleJewelry'>
      {!this.state.jewelry ?
        <div>
          {this.state.jewelryNotFound ?
            <div className='diamondNotFound'>
              <div className='notFoundTitle'>Jewelry Not Found</div>
              <div className='notFoundSubtitle'>This jewelry is not currently available or not found</div>
              <div className='backButtonWrapper'>
                <div className={'backButton actionButton'} onClick={() => this.userNav('jewelry')}>Back to Search</div>
              </div>
            </div> :
            <div className='diamondLoadingWrapper'>
              <RhinoLoading message='Loading jewelry' />
            </div>
          }
        </div> :
        <div>
          <div className={isLoggedIn() ? 'singleDiamondHeader loggedInHeader' : 'singleDiamondHeader'}>Jewelry Details</div>
          <div className='displaySection'>
            <div className='displayControlsWrapper'>
              
            </div>
          </div>
          <div className='infoSection'>
            <div className={'diamondTitle'}>{this.state.jewelry.name || this.state.jewelry.key_text || ''}</div>
            <div className='diamondSku'>{this.state.jewelry.sku || this.state.jewelry.web_item_id}</div>
            <div className='diamondMeasurements'>{this.state.jewelry.group}</div>
            {this.state.jewelry && this.state.jewelry.location_number ?
              <div className='locationRowWrapper'>
                <div className='locationWrapper' style={{ left: '0', textAlign: 'center' }}>
                  <div className='locationIcon'>
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className='locationValue'>{formatLocation({ location: this.state.jewelry.location_number })}</div>
                </div>
              </div> :
              null
            }
            <div className='detailWrapper'>
              <div className='detailBlock'>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Price:</div>
                    <div className='detailValue'>{`$${parseInt(this.state.jewelry.price || this.state.jewelry.sell_price || '0').toFixed(2).toLocaleString()}`}</div>
                  </div>
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Cost:</div>
                    <div className='detailValue'>{this.state.jewelry.cost}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>SKU:</div>
                    <div className='detailValue'>{this.state.jewelry.sku || this.state.jewelry.web_item_id || ''}</div>
                  </div>
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Type:</div>
                    <div className='detailValue'>{this.state.jewelry.jewelry_type}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  {this.state.jewelry.vendor_name && (
                    <div className='detailEntry'>
                      <div className='detailLabel'>Vendor:</div>
                      <div className='detailValue'>{this.state.jewelry.vendor_name}</div>
                    </div>
                  )}
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Polish:</div>
                    <div className='detailValue'>{this.state.jewelry.sku}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='backToResultsWrapper'>
              <div className={'backToResultsButton bottomAction alwaysBottom'} onClick={this.backButtonNav.bind(this)}>Back</div>
              <div className='bottomActionSpacer alwaysBottom'></div>
            </div>
          </div>
        </div>
      }
    </div>;
  }
}
export default SingleJewelry;

function mapStateToProps(state) {
	return {
		auth: state.auth,
		diamonds: state.diamonds,
		users: state.users,
	};
}

export const SingleJewelryContainer = connect(
	mapStateToProps,
	allActionCreators
)(SingleJewelry);
